import create from 'zustand';

type RestrictClassModalState = {
  showRestrictClassModal: boolean;
  setShowRestrictClassModal: (val: boolean) => void;
  showJoinStatusMessage: string;
  setShowJoinStatusMessage: (val: string) => void;
  holdStatusLabel: string;
  setHoldStatusLabel: (val: string) => void;
};

const useRestrictClassModalStore = create<RestrictClassModalState>(set => ({
  showRestrictClassModal: false,
  showJoinStatusMessage: '',
  holdStatusLabel: '',
  setShowRestrictClassModal: (val: boolean) =>
    set({showRestrictClassModal: val}),
  setShowJoinStatusMessage: (val: string) => set({showJoinStatusMessage: val}),
  setHoldStatusLabel: (val: string) => set({holdStatusLabel: val}),
}));

export default useRestrictClassModalStore;
